const getDataAttributeValue = (selector, attr) =>
    document.querySelector(selector)?.getAttribute(attr);

export default getDataAttributeValue
